import {uniq} from "ramda";
import {GetScanJobResultResponse} from "lib/api/wineScannerApi";

export function getSelectedWineIds(resp: GetScanJobResultResponse): string[] {
    const ids: string[] = [];

    const collectFromRecommendation = (wineListingId: string) => {
        const individualSetting = resp.metadata.individual_settings.find(
            s => s.wine_listing_id === wineListingId
        );
        if (individualSetting) {
            ids.push(...(individualSetting.selected_wine_ids ?? []));
            ids.push(...(individualSetting.additional_selected_wine_ids ?? []));
        }
    };

    const wineCategories = resp.metadata.wine_categories;
    if (wineCategories && wineCategories.length > 0) {
        for (const category of wineCategories) {
            if (category.wine_type_key) {
                const section = resp.scan_result.sections.find(
                    s => s.section_type === category.wine_type_key
                );
                if (!section) continue;
                for (const recommendation of section.recommendations) {
                    collectFromRecommendation(recommendation.scanned_wine_info.wine_listing_id);
                }
            } else {
                ids.push(...(category.selected_wine_ids ?? []));
            }
        }
    } else {
        for (const section of resp.scan_result.sections) {
            for (const recommendation of section.recommendations) {
                collectFromRecommendation(recommendation.scanned_wine_info.wine_listing_id);
            }
        }
    }

    ids.push(...(resp.metadata.additional_selected_wine_ids ?? []));

    return uniq(ids);
}
